module.exports = __webpack_public_path__ + "img/图层 31.c4cc2e87.png";